module.exports = __webpack_public_path__ + "img/portfolio-light.bbf83e7a.png";